import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 120000,
});

// Persistent anonymous session id (no auth for MVP)
export function getSessionId() {
  let sid = localStorage.getItem("lg_session_id");
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem("lg_session_id", sid);
  }
  return sid;
}
